import React from "react";
import { useInView } from "react-intersection-observer";

export default function AnimatedSection({
  children,
  className = "",
  animation = "fade-up",
  delay = 0,
  threshold = 0.1,
  triggerOnce = true,
  as: Component = "div",
  ...props
}) {
  const { ref, inView } = useInView({
    triggerOnce,
    threshold,
    rootMargin: "0px 0px -50px 0px",
  });

  const animations = {
    "fade-up": {
      initial: "opacity-0 translate-y-8",
      animate: "opacity-100 translate-y-0",
    },
    "fade-down": {
      initial: "opacity-0 -translate-y-8",
      animate: "opacity-100 translate-y-0",
    },
    "fade-left": {
      initial: "opacity-0 translate-x-8",
      animate: "opacity-100 translate-x-0",
    },
    "fade-right": {
      initial: "opacity-0 -translate-x-8",
      animate: "opacity-100 translate-x-0",
    },
    fade: {
      initial: "opacity-0",
      animate: "opacity-100",
    },
    scale: {
      initial: "opacity-0 scale-95",
      animate: "opacity-100 scale-100",
    },
    blur: {
      initial: "opacity-0 blur-sm",
      animate: "opacity-100 blur-0",
    },
  };

  const anim = animations[animation] || animations["fade-up"];

  return (
    <Component
      ref={ref}
      className={`transition-all duration-500 ease-out will-change-transform ${
        inView ? anim.animate : anim.initial
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...props}
    >
      {children}
    </Component>
  );
}
